import ExternalLink from './ExternalLink';

const Address = ({ color, store }) => (
  <div className="address">
    {/* TODO: add company website? */}
    <h4>
      {store.website ? (
          <ExternalLink color={color} href={store.website}>
            {store.name}
          </ExternalLink>
        ) : (
          store.name
        )
      }
    </h4>
    <p>
      {store.street1}<br />
      {store.street2 ? (<>{store.street2}<br /></>) : null}
      {store.city}, {store.state} {store.zip}
    </p>
  </div>
);

export default Address;
